export default {"src":"/_next/static/media/icon-origin-air-freight.797d7578.svg","height":22,"width":23,"blurWidth":0,"blurHeight":0};